export default "__VITE_ASSET__b80719c6__"